import oceanMain from "../../assets/ocean_main.webp";

function Hero() {
  return (
    <div className="relative w-screen h-screen overflow-hidden">
      <img
        src={oceanMain}
        className="absolute top-0 left-0 w-full h-full object-cover"
        alt="Ocean Hero Background"
      />

      <div className="relative z-10 flex items-center justify-center w-full h-full bg-black/40">
        <div className="overflow-hidden whitespace-nowrap w-full flex">
          {/* First copy */}
          <span className="inline-block text-white text-6xl md:text-[168px] font-spartan font-bold animate-marquee tracking-wide">
            REVELATION / REPENTANCE / GRACE / LOVE / FAITH / PURPOSE /
            FULFILLMENT / REVELATION / REPENTANCE / GRACE / LOVE / FAITH /
            PURPOSE / FULFILLMENT /
          </span>
          {/* Second copy, immediately following */}
          <span className="inline-block text-white text-6xl md:text-[168px] font-spartan font-bold animate-marquee tracking-wide">
            REVELATION / REPENTANCE / GRACE / LOVE / FAITH / PURPOSE /
            FULFILLMENT / REVELATION / REPENTANCE / GRACE / LOVE / FAITH /
            PURPOSE / FULFILLMENT /
          </span>
        </div>
      </div>
    </div>
  );
}

export default Hero;
